const ATTENDANCE_TABLE_READY = "attendances-table-ready"
const SEARCH_TEXT_STATE = "attendances-table-search-text-state"
const ROWS_PER_PAGE_STATE = "attendances-table-rows-per-page-state"
const PAGINATION_STATE = "attendances-table-pagination-state"

const ATTENDANCE_ID_FOR_ACTION = "attendances-table-attendance-id-for-action"

const ADD_EDIT_ATTENDANCE_READY = "add-edit-attendance-ready"


const PREVIOUS_ATTENDANCE_FILTER_STATUS = "previous-attendance-filter-status-action"

const PREVIOUS_ATTENDANCE_FILTER_GROUP_ID = "previous-attendance-filter-group-id-action"


const PREVIOUS_ATTENDANCE_FILTER_CYCLE_ID = "attendances-previous-cycle-id"
const PREVIOUS_ATTENDANCE_FILTER_END_DATE = "attendances-previous-end-date"
const PREVIOUS_ATTENDANCE_FILTER_START_DATE = "attendances-previous-start-date"


const PREVIOUS_ATTENDANCE_WORK_LOCATION_TYPE = "attendances-previous-work-location-type"
const PREVIOUS_ATTENDANCE_WORK_LOCATION_ID = "attendances-previous-work-location-id"

const PREVIOUS_ATTENDANCE_FILTER_CITY_ID = "attendances-previous-filter-city-id"





const initialState = {
    isAttendanceTableReady: true,
    isAddEditAttendanceReady:true,
    attendances: {},

    
    attendanceSelectedId: null,
    
    previousSearchText: "",
    previousRowsPerPageValue: 15,
    previousPaginationValue: 1,

    previousFilterStatus : "",
    previousFilterGroupId : "",

    previousAttendanceCycleId: "",
    previousFilterStartDate: "",
    previousFilterEndDate: "",

    previousWorkLocationType: "",
    previousWorkLocationId: "",

    previousFilterCity:"",
    
}


export default function reducer(state = initialState, action) {
    let duplicateState = null
    switch (action.type) {
        case ATTENDANCE_TABLE_READY:
            return Object.assign({}, state, { isAttendanceTableReady: action.payload })
        case ADD_EDIT_ATTENDANCE_READY:
            return Object.assign({}, state, { isAddEditAttendanceReady: action.payload })
        


        case SEARCH_TEXT_STATE :
            duplicateState = Object.assign({}, state)
            duplicateState.previousSearchText = action.payload
            return Object.assign({}, state, duplicateState)
        
        case ROWS_PER_PAGE_STATE:
            duplicateState=Object.assign({},state)
            duplicateState.previousRowsPerPageValue= action.payload
            return Object.assign({}, state, duplicateState)
        
        case PAGINATION_STATE:
            duplicateState= Object.assign({},state)
            duplicateState.previousPaginationValue = action.payload
            return Object.assign({}, state, duplicateState)

        case ATTENDANCE_ID_FOR_ACTION:
            return Object.assign({}, state, {attendanceSelectedId:action.payload})

        case PREVIOUS_ATTENDANCE_FILTER_STATUS:
            return Object.assign({}, state, {previousFilterStatus:action.payload})

        case PREVIOUS_ATTENDANCE_FILTER_GROUP_ID:
            return Object.assign({}, state, {previousFilterGroupId:action.payload})



        case PREVIOUS_ATTENDANCE_FILTER_CYCLE_ID:
            return Object.assign({}, state, {previousAttendanceCycleId:action.payload})
        case PREVIOUS_ATTENDANCE_FILTER_END_DATE:
            return Object.assign({}, state, {previousFilterEndDate:action.payload})

        case PREVIOUS_ATTENDANCE_FILTER_START_DATE:
            return Object.assign({}, state, {previousFilterStartDate:action.payload})



        case PREVIOUS_ATTENDANCE_WORK_LOCATION_TYPE:
            return Object.assign({}, state, {previousWorkLocationType:action.payload})
        case PREVIOUS_ATTENDANCE_WORK_LOCATION_ID:
            return Object.assign({}, state, {previousWorkLocationId:action.payload})

        case PREVIOUS_ATTENDANCE_FILTER_CITY_ID:
            return Object.assign({}, state, {previousFilterCity:action.payload})



        default:
        return state
    
    }

}

export function attendanceTableReady(data) {
    return {
        type: ATTENDANCE_TABLE_READY,
        payload: data
    }
}


export function addEditAttendanceReady(data) {
    return {
        type: ADD_EDIT_ATTENDANCE_READY,
        payload: data
    }
}



export function searchTextState(searchText){
    return {
        type:SEARCH_TEXT_STATE,
        payload:searchText
    }
}

export function rowsPerPageState(rows){
    return {
        type:ROWS_PER_PAGE_STATE,
        payload:rows
    }
}

export function paginationState(pageNo){
    return{
        type:PAGINATION_STATE,
        payload:pageNo
    }
}

export function attendanceIdForAction(attendanceId){
    return{
        type:ATTENDANCE_ID_FOR_ACTION,
        payload:attendanceId
    }
}

export function previousFilterStatus(filterVal){
    return{
        type:PREVIOUS_ATTENDANCE_FILTER_STATUS,
        payload:filterVal
    }
}


export function previousFilterGroupId(filterVal){
    return{
        type:PREVIOUS_ATTENDANCE_FILTER_GROUP_ID,
        payload:filterVal
    }
}


export function previousAttendanceCycleId(fiter_val){
    return{
        type:PREVIOUS_ATTENDANCE_FILTER_CYCLE_ID,
        payload:fiter_val
    }
}


export function previousFilterStartDate(fiter_val){
    return{
        type:PREVIOUS_ATTENDANCE_FILTER_START_DATE,
        payload:fiter_val
    }
}

export function previousFilterEndDate(fiter_val){
    return{
        type:PREVIOUS_ATTENDANCE_FILTER_END_DATE,
        payload:fiter_val
    }
}



export function previousWorkLocationType(fiter_val){
    return{
        type:PREVIOUS_ATTENDANCE_WORK_LOCATION_TYPE,
        payload:fiter_val
    }
}


export function previousWorkLocationId(fiter_val){
    return{
        type:PREVIOUS_ATTENDANCE_WORK_LOCATION_ID,
        payload:fiter_val
    }
}
export function previousFilterCity(fiter_val){
    return{
        type:PREVIOUS_ATTENDANCE_FILTER_CITY_ID,
        payload:fiter_val
    }
}



// WEBPACK FOOTER //
// ./src/modules/Attendance/redux/attendances.js